/**
 * @fileoverview StaggerConfig → per-item animation-delay math.
 * @module screen-view-v2/animations/stagger
 */

import type { StaggerConfig } from '@segmently/schema-models/v2';

export const DEFAULT_DELAY_PER_ITEM_MS = 50;

/**
 * Delay for the item at `index` (0-based display position).
 *
 * delay = startDelay + min(index * delayPerItem, maxDelay)
 *
 * `maxDelay` caps the accumulated per-item share (large lists stop growing),
 * NOT the total — `startDelay` always applies on top.
 */
export function computeStaggerDelay(
  index: number,
  stagger: StaggerConfig | null | undefined,
): number {
  if (!stagger || index <= 0) {
    return Math.max(stagger?.startDelay ?? 0, 0);
  }
  const delayPerItem = stagger.delayPerItem ?? DEFAULT_DELAY_PER_ITEM_MS;
  const startDelay = Math.max(stagger.startDelay ?? 0, 0);
  const accumulated = index * Math.max(delayPerItem, 0);
  const capped = stagger.maxDelay != null
    ? Math.min(accumulated, Math.max(stagger.maxDelay, 0))
    : accumulated;
  return startDelay + capped;
}
